import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-110" data-mp="1geiki8ubgix4">
      <div className="mx-auto max-w-3xl" data-id="element-111" data-mp="2dzxti7x0wdj7">
        <div id="faq-title" data-id="element-112" data-mp="291d3107kp87y">
          <SectionHeading title="Frequently asked questions" data-id="element-113" data-mp="2913e7fy9l73u" />
        </div>

        <ul className="mt-10 divide-y divide-brand-100 border-y border-brand-100" data-id="element-114" data-mp="242061mmzmkrn">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-115" data-mp="1z5jhirbvm4e1" data-mpi={i}>
                <button type="button" className="flex w-full items-center justify-between gap-4 py-5 text-left" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} data-id="element-116" data-mp="snmnmxb06xj0">
                  <span className="text-[17px] font-bold text-ink" data-id="element-117" data-mp="ufzke4y3m15d">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-118" data-mp="fk9u3ulvr1uu" />
                </button>
                <AnimatePresence initial={false} data-id="element-119" data-mp="biomoos47fs1">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-120" data-mp="3syof4l2hxj65">
                      <div className="space-y-2 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-121" data-mp="1ugumnwcgebqk">
                        {f.a.map(p => <p key={p} data-id="element-122" data-mp="1pp33w7zjhaaz">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <SectionCta label="I want my deck now" data-id="element-123" data-mp="1fpviqymkcbdb" />
      </div>
    </section>;
}